// extracted by mini-css-extract-plugin
export var container = "_r4-0";
export var table = "_r4-2";
export var tableWrapper = "_r4-1";